import { NavigationError } from '@angular/router';

/**
 * Depois de um deploy, quem estava com o portal aberto ainda tem o JavaScript antigo, que
 * aponta para arquivos de tela que não existem mais. A navegação falhava em silêncio: o
 * clique "não fazia nada" (aconteceu com Manutenções e com o Funil comercial). Aqui a
 * página recarrega uma vez no endereço que a pessoa tentou abrir, já com a versão nova.
 */
const STALE_CHUNK =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk [\w-]+ failed/i;
const RELOAD_KEY = 'liv-stale-chunk-reload';

export function reloadOnStaleChunk(error: NavigationError): void {
  const message = String((error.error as Error)?.message ?? error.error ?? '');
  if (!STALE_CHUNK.test(message)) return;
  try {
    // Uma vez por endereço: se o arquivo faltar mesmo depois de recarregar, não entra em laço.
    if (sessionStorage.getItem(RELOAD_KEY) === error.url) return;
    sessionStorage.setItem(RELOAD_KEY, error.url);
  } catch {
    // Sem sessionStorage (navegação anônima restrita) ainda vale recarregar uma vez.
  }
  window.location.assign(error.url);
}
